import angular from "angular"

class BulkExportController {

   $scope: any
   translationService: any
   emailService: any
   alerts: any
   recaptcha: any
   $http: any
   $window: any
   config: any
   api: any
   appState: any

   constructor($scope: any, translationService: TranslationService, emailService: EmailService, recaptcha: RecaptchaService, config: ConfigService, api: ApiService, alerts: AlertService, appState: AppStateService, $window: any) {
      this.$scope = $scope
      this.translationService = translationService
      this.$scope.i18n = this.translationService
      this.emailService = emailService
      this.recaptcha = recaptcha
      this.config = config
      this.api = api
      this.$scope.recaptchaIsValid = false

      this.$scope.$on("recaptchaValidated", (event: any, isValid: boolean) => {
      this.$scope.recaptchaIsValid = isValid

      if (!this.$scope.$$phase) {
         this.$scope.$applyAsync()
      }
      })

      this.alerts = alerts
      this.appState = appState
      this.$window = $window


      this.export = this.export.bind(this)
      this.isEmailInvalid = this.isEmailInvalid.bind(this)
      this.displayBulkExportLimitWarning = this.displayBulkExportLimitWarning.bind(this)
      this.getDefaultMessage = this.getDefaultMessage.bind(this)
      this.$scope.export = this.export
      this.$scope.displayBulkExportLimitWarning = this.displayBulkExportLimitWarning
   }

   isEmailInvalid(type: string) {
      return this.emailService.isEmailInvalid(this.$scope, type)
   }

   displayBulkExportLimitWarning() {
      return this.$scope.getRecordCount() > 1000 && this.config.data.bulkExport?.enabled || false
   }

   getDefaultMessage() {
      const query = this.appState.params.q
      const summonUrl = this.$window.location.href
      let message = this.translationService.translations.BULK_EXPORT_DEFAULT_MESSAGE

      if (message.includes('{query}')) {
         message = message.replace('{query}', query)
      }

      if (message.includes('{summonUrl}')) {
         message = message.replace('{summonUrl}', summonUrl)
      }

      return message
   }

   export() {
      if (this.alerts?.resetAlert) {
         this.alerts.resetAlert("bulkExportError")
      }

      // Enterprise flow — get token dynamically
      return this.recaptcha.execute("bulk_export")
         .then((token: string) => {

            if (!token) {
            this.alerts?.toast("bulkExportError")
            throw new Error("no_token")
            }

            const reportData: { [key: string]: any } = {
            email: this.$scope.recipient,
            libhash: this.config.data.bulkExport.libhash,
            message: this.$scope.message || this.getDefaultMessage(),
            reportTitle: this.translationService.translations.BULK_EXPORT_REPORT_TITLE,
            emailSubject: this.translationService.translations.BULK_EXPORT_EMAIL_SUBJECT,

            // Backend expects THIS
            captchaValidation: token
            }

            // Add all facets taken from this.appState.params
            for (const key in this.appState.params) {
            reportData[key] = this.appState.params[key]
            }

            return this.api.bulkExport(reportData)
         })

         .then((response: any) => {
            this.$scope.close()

            if (response?.data?.success) {
            this.alerts.toast("bulkExportSuccess")
            } else {
            this.alerts.toast("bulkExportError")
            }

            return response
         })

         .catch((err: any) => {
            console.error("Bulk export failed:", err)
            this.$scope.close()
            this.alerts.toast("bulkExportError")
            return
         })
   }
}
BulkExportController.$inject = ['$scope', 'translationService', 'emailService', 'recaptchaService', 'configService', 'apiService', 'alertService', 'appStateService', '$window']


angular.module('summonApp.controllers')
   .controller('BulkExportCtrl', BulkExportController)
